module.exports = __webpack_public_path__ + "img/myz-title-white.97731223.png";